module.exports = __webpack_public_path__ + "img/meeting-time.e87c09ae.svg";